<template>
  <el-select
    v-model="value"
    clearable
    size="large"
    filterable
    placeholder="Select languages"
    multiple
    class="w-100"
  >
    <el-option
      v-for="item in languages"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "LanguagesDropdown",
  data() {
    return {
      value: ""
    };
  },
  methods: {
    ...mapActions("ListsModule", ["fetchLanguages"])
  },
  mounted() {
    this.fetchLanguages();
  },
  computed: {
    ...mapGetters("ListsModule", ["languages"])
  }
});
</script>
